<template>
     <div class="pay">
         跳转app中...
     </div>
</template>

<script>
export default {
  name: "appPayReturnPage",
  setup () {
    console.log('456')

    setTimeout(()=>{
      window.location.href = 'yihu365.demander.cn://';
    },1000)

     // window.location.href = 'h5.yihu365.com';
     console.log('123')
  }
}
</script>

<style scoped>
.pay{
  width: 100%;
  height:100vh;
  background: #00C291;
  text-align: center;
  box-sizing: border-box;
  color:#fff;
  padding-top: 40px;
}
</style>
